var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignatureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 0.166687C2.78033 0.166687 0.166992 2.78002 0.166992 6.00002C0.166992 9.22002 2.78033 11.8334 6.00033 11.8334C9.22033 11.8334 11.8337 9.22002 11.8337 6.00002C11.8337 2.78002 9.22033 0.166687 6.00033 0.166687ZM4.41949 8.50252L2.32533 6.40835C2.09783 6.18085 2.09783 5.81335 2.32533 5.58585C2.55283 5.35835 2.92033 5.35835 3.14783 5.58585L4.83366 7.26585L8.84699 3.25252C9.07449 3.02502 9.44199 3.02502 9.66949 3.25252C9.89699 3.48002 9.89699 3.84752 9.66949 4.07502L5.24199 8.50252C5.02033 8.73002 4.64699 8.73002 4.41949 8.50252Z",
    fill: "#7075F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/SignatureIcon.67b12ee0cdaea77041d89ed5683de611.svg";
export { ForwardRef as ReactComponent };